import { axios } from '@/api/request'

/**
 * api接口列表
 */
const api = {
  login:'/qywxLogin/',
  getclients_all_forsaler:'/teams/clients/getclients_all_forsaler/'

}

export function login (data) {
  return axios({
    url: api.login,
    method: 'post',
    data
  })
}

export function getclients_all_forsaler (params) {
  return axios({
    url: api.getclients_all_forsaler,
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/views/main/api.js